import { UAParser } from "ua-parser-js";
import { auth, db } from "../FirebaseConfig";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

const ErrorTypes = {
  API: 'Api',
  NETWORK: 'Network',
  RENDER: 'Web',
  AUTH: 'Web',
  VALIDATION: 'Web',
};

const getErrorType = (error) => {
  // Check for API errors (typically have a response or are axios errors)
  if (error.isAxiosError || (error.response && error.request)) {
    return ErrorTypes.API;
  }
  
  // Network errors (failed to fetch, offline, etc.)
  if (error.message.includes('Network Error') || error.message.includes('Failed to fetch')) {
    return ErrorTypes.NETWORK;
  }
  
  // Authentication errors
  if (error.message.includes('auth/') || error.message.includes('permission denied')) {
    return ErrorTypes.AUTH;
  }
  
  // Validation errors
  if (error.message.includes('validation') || error.message.includes('invalid')) {
    return ErrorTypes.VALIDATION;
  }
  
  // React render errors
  if (error.message.includes('rendering') || error.message.includes('component')) {
    return ErrorTypes.RENDER;
  }
  
  return ErrorTypes.RENDER;
};

export const logError = async (error, info) => {
  const parser = new UAParser(navigator.userAgent);
  const { browser, os, device } = parser.getResult();
  const errorType = getErrorType(error);
  
  const errorData = {
    timestamp: serverTimestamp() ,
    errorMessage: error.message,
    errorStack: error.stack,
    errorType: errorType,  // Add error type here
    componentStack: info?.componentStack || 'No component stack',
    userId: auth.currentUser?.uid || 'anonymous',
    url: window.location.href,
    browser: `${browser.name} ${browser.version}`,
    os: `${os.name} ${os.version}`,
    device: device.type ? device.type.charAt(0).toUpperCase() + device.type.slice(1) : 'Desktop',
  };

  try {
    await addDoc(collection(db, 'errors'), errorData);
  } catch (dbError) {
    console.error('Failed to log to Firestore:', dbError);
  }
};